import SuspenseDimmer from "global/components/alerts/SuspenseDimmer"
import TrackerProvider from "../../../../../global/cnr/contexts/TrackerContext"
import SportsOrganizationProvider from "projectSpecific/sports/cnr/contexts/SportsOrganizationContext"
import SportsDistrictProvider from "projectSpecific/sports/cnr/contexts/SportsDistrictContext"
import SportsSeasonProvider from "projectSpecific/sports/cnr/contexts/SportsSeasonContext"
import React, { Suspense } from "react"
import GolfTournamentProvider from "projectSpecific/golf/cnr/contexts/GolfTournamentContext"
import { useRenders } from "global/cnr/contexts/useHelpers/useRenders"
// import { useRenders } from "./useHelpers/useRenders"

export const SportsProviders = ({ children, component_content, organizationsKey, districtsKey, sportsKey }) => {

  useRenders('SportsProviders', true);

  return (
    <Suspense fallback={<SuspenseDimmer origin='SportsSeasonLayout' />}>
      <TrackerProvider>
        <SportsOrganizationProvider organizationsKey={organizationsKey}>
          <SportsDistrictProvider districtsKey={districtsKey}>
            <SportsSeasonProvider sportsKey={sportsKey}>
              {children}
            </SportsSeasonProvider>
          </SportsDistrictProvider>
        </SportsOrganizationProvider>
      </TrackerProvider>
    </Suspense>
  )
}

export const GolfLayout = React.memo(({ children }) => {
  return (
    <Suspense fallback={<SuspenseDimmer origin={'PageComponentContext'} />}>
      <GolfTournamentProvider fromPage={true}>
        {children}
      </GolfTournamentProvider>
    </Suspense>
  )
})